/**
 * Awaitable timeout
 * @param s Seconds
 */
async function sleep(s: number): Promise<void> {
    return new Promise((resolve) => setTimeout(() => resolve(), s * 1000));
}

export default sleep;
